import React from 'react'
import { Region } from '@enonic/react-components';

import Employee from '/react4xp/components/pages/employee'

import { EmployeeProps } from './employee.d'

function EmployeeLayout(props: EmployeeProps) {
    return (
        <>
            <Employee
                {...props}
            />
        </>
    )
}

export default (props) => <EmployeeLayout {...props} />
